const locale = {
    placeholder: 'အချိန်ရွေးပါ။',
    rangePlaceholder: ['စတင်ချိန်', 'ကုန်ဆုံးချိန်'],
};
export default locale;
